const GRADIENT_HOVER = 'url(#gradient-dark)'
const GRADIENT_NORMAL = 'url(#gradient-light)'

window.addEventListener('load', e => {

    const svg = document.querySelector('.s-motion__stream')
    if(!svg) return

    const lines = svg.contentDocument.children[0].querySelector('.lines').querySelectorAll('path')

    lines.forEach((line, idx) => {
        const prev = lines[idx - 1]
        const next = lines[idx + 1]

        line.addEventListener('mouseover', e => {
            [prev, next, line].forEach(el => {
                if(!el) return;
                el.style.fill = GRADIENT_HOVER
            })
        })
        line.addEventListener('mouseout', e => {
            [prev, next, line].forEach(el => {
                if(!el) return;
                el.style.fill = GRADIENT_NORMAL
            })
        })
    })

})